import PasswordIcon from '../../../public/static/images/new_search/icons/icon-password.svg';
import CalendarIcon from '../../../public/static/images/new_search/icons/icon-calendar.svg';
import MoonIcon from '../../../public/static/images/new_search/icons/icon-moon.svg';
import { setAdriverSelectedCity, setCurrentState } from '../../../actions';
import { onClickProps, RentalTabsIdEnum } from './types';
import PashaLogo from '../../../public/static/images/pasha-logo-gray.svg';
import {
  Cities,
  BUILDING_TYPE_ID,
  SEARCH_RESULT_ROUTES
} from '../../../utils/helpers/constants';

export const mobileTabsConfig = [
  {
    id: RentalTabsIdEnum.buyTab,
    href: SEARCH_RESULT_ROUTES.SALE,
    cypress: 'tab-link',
    icon: PasswordIcon,
    text: 'new_search.sell',
    stat: 'new-search-buy-button',
    onClick: ({ change, dispatch, values }: onClickProps) => {
      change('category_id', BUILDING_TYPE_ID.FLAT_ALL);
      change('city_id', Cities.Baku.id);
      change('paid_daily', undefined);
      dispatch(
        setCurrentState({
          ...values,
          city_id: Cities.Baku.id,
          leased: 'false',
          category_id: BUILDING_TYPE_ID.FLAT_ALL
        })
      );
      dispatch(setAdriverSelectedCity(Cities.Baku.az));
    }
  },
  {
    id: RentalTabsIdEnum.rentTab,
    href: SEARCH_RESULT_ROUTES.RENT,
    cypress: 'tab-link',
    icon: CalendarIcon,
    text: 'new_search.rent',
    stat: 'new-search-rent-button',
    onClick: ({ change, dispatch, values }: onClickProps) => {
      change('category_id', BUILDING_TYPE_ID.FLAT_ALL);
      change('leased', 'true');
      dispatch(
        setCurrentState({
          ...values,
          city_id: Cities.Baku.id,
          leased: 'true',
          category_id: BUILDING_TYPE_ID.FLAT_ALL
        })
      );
      dispatch(setAdriverSelectedCity(Cities.Baku.az));
    }
  },
  {
    id: RentalTabsIdEnum.rentDailyTab,
    href: SEARCH_RESULT_ROUTES.RENT_DAILY,
    icon: MoonIcon,
    cypress: 'tab-link',
    text: 'search.form.paid_daily',
    stat: 'new-search-paid-daily-button',
    onClick: ({ change, dispatch, values }: onClickProps) => {
      change('category_id', BUILDING_TYPE_ID.FLAT_ALL);
      change('leased', 'true');
      change('paid_daily', ['true']);
      dispatch(
        setCurrentState({
          ...values,
          city_id: Cities.Baku.id,
          leased: 'true',
          category_id: BUILDING_TYPE_ID.FLAT_ALL,
          paid_daily: ['true']
        })
      );
      dispatch(setAdriverSelectedCity(Cities.Baku.az));
    }
  },
  {
    id: RentalTabsIdEnum.pashaTab,
    href: '/pasha',
    icon: PashaLogo,
    cypress: 'pasha',
    text: 'new_search.pasha',
    stat: 'pasha-main-mobile',
    onClick: () => {}
  }
];
